import React from 'react';

const classNames = require('html-classnames');

interface PaginationProps {
  url: string;
  page: number;
  pages: number;
  total: number;
  size: number;
}

const Pagination: React.FC<PaginationProps> = ({ url, page, pages, total, size }) => {
  const toShow = [];

  if (pages < 6) {
    for (let i = 1; i <= pages; i += 1) {
      toShow.push(i);
    }
  } else {
    toShow.push(1);
    if (page > 4) {
      toShow.push('...');
    }
    if (page === 4) {
      toShow.push(2);
    }

    if (page > 2) {
      toShow.push(page - 1);
    }

    if (page > 1 && page < pages) {
      toShow.push(page);
    }

    if (page < pages - 1) {
      toShow.push(page + 1);
    }

    if (page < pages - 3) {
      toShow.push('...');
    }

    if (page === pages - 3) {
      toShow.push(pages - 1);
    }

    toShow.push(pages);
  }

  return (
    <nav className="pagination">
      <ul>
        { page > 1 && <li className="paginationItem"><a href={`${url}/${page - 1}`}>&lt;</a></li> }
        {toShow.map((p) => (
          <li key={p} className={classNames('paginationItem', { '--active': p === page, '--separator': p === '...' })}>
            <a href={`${url}/${p}`}>{p}</a>
          </li>
        ))}
        { (page < pages) && <li className="paginationItem"><a href={`${url}/${page + 1}`}>&gt;</a></li> }
      </ul>
    </nav>
  );
};

interface ListProps<T> {
  items: T[];
  url: string;
  page: number;
  pages: number;
  total: number;
  size: number;
  ItemComponent: React.FC<T>;
  className: string;
}

export const List: React.FC<ListProps<any>> = ({ url, items, page, pages, total, size, ItemComponent, className }) => (
  <div className={classNames(className, 'list')}>
    <div className="container">
      {items?.map((item, index: number) => <ItemComponent key={index} url={url} {...item} />)}
    </div>
    <Pagination url={url} page={page} pages={pages} total={total} size={size} />
  </div>
);
